module.exports = __webpack_public_path__ + "img/hr-rock-big-20.30ce7a81.png";